export default "/images/module_icons_no_bg.png?675d5e304cbffc284b59afd999d4f91a";